import { z } from "zod";
import zodToCamelCase from "zod-to-camel-case";

import {
  _stateSchema,
  restrictionLevel,
} from "@/schema/public/components/base/base.schema";

export const mvLessonRestrictionLevelsSchema = z.object({
  lesson_id: z.number().int(),
  _state: _stateSchema,
  slug: z.string(),
  tpc_media_max_restriction: restrictionLevel.nullable(),
  tpc_quizimages_max_restriction: restrictionLevel.nullable(),
  tpc_downloadablefiles_max_restriction: restrictionLevel.nullable(),
  tpc_works_max_restriction: restrictionLevel.nullable(),
});

export type MvLessonRestrictionLevels = z.infer<
  typeof mvLessonRestrictionLevelsSchema
>;

export const mvLessonRestrictionLevelsSchemaCamel = zodToCamelCase(
  mvLessonRestrictionLevelsSchema,
);
export type MvLessonRestrictionLevelsCamel = z.infer<
  typeof mvLessonRestrictionLevelsSchemaCamel
>;
